import { useEffect, useState } from 'react';
import * as React from 'react';
import axiosClient from '../axiosClient';
import MotorPriceInfo from './motor-price-calculator/MotorPriceInfo';
import JobPriceOverview from './JobPriceOverview';

type AppProps = {
  market: string,
  orgId: number | undefined,
};

function App({
  market, orgId,
}: AppProps) {
  const [isInCorporateGroup, setIsInCorporateGroup] = useState<boolean | null>(orgId !== undefined ? null : false);
  const fetchCorporateGroupForOrgId = async () => axiosClient.get('api/corporate-group', {
    params: { orgId },
  });

  useEffect(() => {
    if (orgId !== undefined) {
      fetchCorporateGroupForOrgId()
        .then((result) => setIsInCorporateGroup(!!result.data.corporateGroup))
        .catch(() => setIsInCorporateGroup(false));
    }
  }, []);

  function getDiscountText() {
    const group = isInCorporateGroup ? 'ditt konsern' : 'din bedrift';
    return isInCorporateGroup === null ? '' : `Annonsepriser beregnes ut fra hvilken type annonse som publiseres, samt hvor mange annonser ${group} har lagt ut i løpet av de siste 365 dagene. `;
  }
  return (
    <>
      <p className="mb-32">
        {getDiscountText()}
        Her finner du prisen på den neste annonsen du legger ut.
      </p>
      <>
        {((market === 'JOB' && orgId) || !market) && <JobPriceOverview orgId={orgId} />}
        {((market === 'MOTOR' && orgId) || !market) && <MotorPriceInfo orgId={orgId} />}
      </>
    </>
  );
}

export default App;
